import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useMediaQuery } from 'react-responsive';
import Loader from '@lightbox/kendo-react-toolkit/base/Loader';
import Intercom from '@intercom/messenger-js-sdk';
import AppHeader from './AppHeader';
import AppLayout from './AppLayout';
import { getApplications } from '../config/applications';
import ResponsiveContext from '../utils/responsive';
import { getEnv } from '../utils/helpers';

function Main() {
    const { authState, oktaAuth } = useOktaAuth();
    const [user, setUser] = useState(null);
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1224 });
    const isMobileOrTablet = isMobile || isTablet;
    const viewport = { isMobile, isTablet, isMobileOrTablet };

    useEffect(() => {
        if (!authState.isAuthenticated) {
            // When user is not authenticated, forget any user info
            setUser(null);
        } else {
            oktaAuth.getUser().then((userInfo) => {
                setUser(userInfo);
            });
        }
    }, [authState, oktaAuth]); // Update if authState changes

    if (!user) {
        return (
            <Loader
                size="large"
                style={{ alignItems: 'center', height: '100vh', justifyContent: 'center' }}
                themeColor="primary"
                type="pulsing"
            />
        );
    }

    if (authState.isAuthenticated && user) {
        const intercomEnabled = getEnv('REACT_APP_INTERCOM_ENABLED');
        if (intercomEnabled === 'true') {
            Intercom({
                app_id: getEnv('REACT_APP_INTERCOM_APP_ID'),
                custom_launcher_selector: `#${getEnv('REACT_APP_INTERCOM_LAUNCHER_SELECTOR')}`,
                hide_default_launcher: true,
                user_id: user.sub,
                name: user.name,
                email: user.email,
                created_at: user.updated_at,
                company: {
                    company_id: user['lightbox.membershipID'],
                    name: user.organization,
                },
                SysID: user['lightbox.spatialstream.account'],
                OktaID: user.sub,
            });
        }

        return (
            <ResponsiveContext.Provider value={viewport}>
                <div id="app-wrapper">
                    <AppHeader user={user} />
                    <AppLayout applications={getApplications(user)} />
                </div>
            </ResponsiveContext.Provider>
        );
    }

    return null;
}

export default Main;
